import React from "react";
import { useNavigate } from "react-router-dom";
import { PageHeader } from "@ant-design/pro-components";
import {
  Layout,
  Breadcrumb,
  Row,
  Col,
  Form,
  Input,
  Button,
  Typography,
  notification,
} from "antd";
import SwatchColorPicker from "components/Utils/SwatchColorPicker";

/**
 * Actions
 */
import { addCategoryObj } from "auth/actions/objActions";

/**
 * Components
 */
import TopBar from "components/NavBar/TopBar";
import DrawerSider from "components/NavBar/DrawerSider";
import { LayoutTopSide } from "components/NavBar/styles";
import { PageHeaderDecorator } from "assets/icons";
import { useSelector } from "react-redux";

const { Content } = Layout;
const { Paragraph } = Typography;
const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
  },
};
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 16,
      offset: 8,
    },
  },
};

export default function NewFormCategory() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const user = useSelector((state) => state.session.user);
  const company = useSelector((state) => state.user.company);
  const routes = [
    {
      breadcrumbName: "Categorias",
      href: "/formularios/categoria/todas",
    },
    {
      breadcrumbName: "nova",
    },
  ];
  const content = (
    <Paragraph style={{ paddingBottom: "2rem" }}>
      Crie categorias para agrupar formulários e personalizar a visualização
      para seus usuários.
    </Paragraph>
  );
  const ContentAlternative = ({ children, extraContent }) => (
    <Row>
      <div style={{ flex: 1 }}>{children}</div>
      <div className="image">{extraContent}</div>
    </Row>
  );

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  /**
   * Adiciona nova categoria
   * @param {*} values
   */
  const onFinish = (values) => {
    addCategoryObj({
      categoryName: values.name.trim(),
      categoryColor: values.color,
      unitId: company.unitId,
      companyId: company.companyId,
      createdBy: user.sub
    })
      .then(async (response) => {
        if (response.success) {
          notification["success"]({
            message: "Sucesso",
            description: response.message
              ? response.message
              : "Algo está errado, tente novamente!",
          });
          await sleep(1000);
          window.location.href = "/formularios/categoria/todas";
        } else {
          notification["error"]({
            message: "Erro",
            description: response.message
              ? response.message
              : "Algo está errado, tente novamente!",
          });
        }
      })
      .catch((err) =>
        notification["error"]({
          message: "Erro",
          description: err.message
            ? err.message
            : "Algo está errado, tente novamente!",
        })
      );
  };

  return (
    <Layout
      style={{
        height: "100vh",
      }}
    >
      <LayoutTopSide>
        <TopBar />
        <Layout>
          <DrawerSider />
          <Layout style={{ padding: "0 24px 24px", minHeight: "100vh" }}>
            <PageHeader
              className="site-page-header"
              style={{ margin: "16px 0 24px 0", background: "var(--cp-surface)" }}
              title="Nova categoria"
              onBack={() => window.history.back()}
              subTitle="Crie categorias para seus formulários."
              breadcrumb={
                <Breadcrumb>
                  {routes.map((a) =>
                    a.hasOwnProperty("href") ? (
                      <Breadcrumb.Item key={Math.random()}>
                        <a href onClick={() => navigate(a.href)}>
                          {a.breadcrumbName}
                        </a>
                      </Breadcrumb.Item>
                    ) : (
                      <Breadcrumb.Item>{a.breadcrumbName}</Breadcrumb.Item>
                    )
                  )}
                </Breadcrumb>
              }
            >
              <ContentAlternative extraContent={<PageHeaderDecorator alt="content" width="100%" />}>
                {content}
              </ContentAlternative>
            </PageHeader>
            <Content
              className="site-layout-background"
              style={{
                padding: 46,
                margin: 0,
                minHeight: 280,
                background: "var(--cp-surface)",
              }}
            >
              <Row gutter={16}>
                <Col xs={24} lg={16}>
                  <Form
                    {...formItemLayout}
                    form={form}
                    name="newCategory"
                    initialValues={{
                      color: {
                        hsl: {
                          h: 198.67219917012446,
                          s: 0.9757085020242916,
                          l: 0.4843137254901961,
                          a: 1,
                        },
                        hex: "#03a9f4",
                        rgb: {
                          r: 3,
                          g: 169,
                          b: 244,
                          a: 1,
                        },
                        hsv: {
                          h: 198.67219917012446,
                          s: 0.9877049180327869,
                          v: 0.9568627450980393,
                          a: 1,
                        },
                        oldHue: 122.42424242424241,
                        source: "hex",
                      },
                    }}
                    onFinish={onFinish}
                    scrollToFirstError
                  >
                    <Form.Item
                      name="name"
                      label="Nome"
                      rules={[
                        {
                          required: true,
                          message:
                            "Por favor insira um nome para este formulário!",
                          whitespace: true,
                        },
                      ]}
                      normalize={(value) =>
                        value
                          .toLowerCase()
                          .split(" ")
                          .map(
                            (y) => y.charAt(0).toUpperCase() + y.substring(1)
                          )
                          .join(" ")
                      }
                    >
                      <Input />
                    </Form.Item>
                    <Form.Item name="color" label="Cor">
                      <SwatchColorPicker />
                    </Form.Item>
                    <Form.Item {...tailFormItemLayout}>
                      <Button type="primary" htmlType="submit">
                        Adicionar categoria
                      </Button>
                    </Form.Item>
                  </Form>
                </Col>
              </Row>
            </Content>
          </Layout>
        </Layout>
      </LayoutTopSide>
    </Layout>
  );
}
